import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IDataGenericText } from '@app/interfaces/idata-grouped';
import { NouisliderComponent } from 'ng2-nouislider';

@Component({
  selector: 'input-slider',
  templateUrl: './input-slider.component.html',
  styleUrls: ['./input-slider.component.css']
})
export class InputSliderComponent {

  @Input() id: string = '';
  @Input() title: string = '';
  @Input() control: UntypedFormControl;
  @Input() titleValuesPlural: string = '';
  @Input() titleValuesSingular: string = '';
  @Input() range: { min: number; max: number; step: number; } = { min: 0, max: 100, step: 1 };
  @Input() format: string = '';
  @Input() secondaryMaxText: string = '';
  @Input() handleMaxText: boolean = true;
  @Input() connect: Array<boolean> | string = [false, true, false];
  @Input() dataSelectLabel: Array<IDataGenericText> = [];
  @Input() maxRange: number = 0;


  @Output() changeValuesEvent = new EventEmitter<undefined>();

  @ViewChild('nouisliderlinear') inputSlider: NouisliderComponent;
  public labelFrom: string = '';
  public labelTo: string = '';
  public invalidMaxRange: boolean = false;

  constructor() { }

  onChangeValuesSlider(): void {
    this.changeValuesEvent.next(undefined);

    this.control.markAllAsTouched();
  }

  onUpdateValuesSlider() {

    if (!(this.dataSelectLabel.length > 0 || this.maxRange > 0))
      return;

    const valFrom: number = this.control.value[0];
    const valTo: number = this.control.value[1];

    if (this.dataSelectLabel.length > 0) {
      this.labelFrom = this.dataSelectLabel.find(e => e.id === valFrom)?.text || 'No seleccionado';
      this.labelTo = this.dataSelectLabel.find(e => e.id === valTo)?.text || 'No seleccionado';
    }

    if (this.maxRange > 0) {
      this.invalidMaxRange = ((+valTo - +valFrom) > this.maxRange)
    }

  }
}
